export default __webpack_public_path__ + "static/stavby-sever-sklo-a87592a17e899863b018d2c8771a1808.png";